module.exports = __webpack_public_path__ + "static/media/Slide1.489384e9.mp4";